<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Loader } from '@client/components/loader';
  import { getNotificationsContext } from '@client/components/notifications';

  import { VideoUploadForm } from '@client/pages/manage/assets/modals/shared';

  import { AssetsService } from '@client/services/assets';

  import { isValidUrl } from '@common/utils/validation';

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  export let show = false;
  export let refetch = false;

  let isUpdating = false;
  let currentRulenames = [];
  let invalidRulename = false;
  let errorMessage = '';
  let rulename = '';
  let uploadError = false;
  let url = '';
  let validationError = false;

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  const onClose = () => {
    errorMessage = '';
    rulename = '';
    uploadError = false;
    url = '';
    validationError = false;

    show = false;
  };

  const onValidation = () => {
    validationError = !isValidUrl(url);

    if (validationError) {
      errorMessage = $format('label.VIDEO_MODAL_VALIDATION_ERORR_MESSAGE');
    }
  };

  const onUploadVideo = async () => {
    uploadError = false;

    isUpdating = true;

    const data = {
      rulename: rulename,
      url: url
    };

    const response = await AssetsService.addVideo(data);

    isUpdating = false;

    if (response?.status >= 400) {
      notify($format('label.FAILURE.ASSET_UPLOAD', { values: { asset: rulename } }), 'error');

      uploadError = true;

      errorMessage = response.message;

      return;
    }

    notify($format('label.SUCCESS.ASSET_UPLOAD', { values: { asset: rulename } }));

    setTimeout(() => (show = false), 200);

    refetch = true;
  };

  onMount(async () => {
    const response = await AssetsService.getAllVideos();

    currentRulenames = Array.isArray(response) ? response.map(({ rulename }) => rulename) : [];
  });

  $: invalidRulename = currentRulenames.includes(rulename.toLowerCase());
</script>

<Modal bind:isOpen={show} close={false} size="lg" fullscreen="lg">
  <Loader backdrop show={isUpdating} />
  <ModalBody id="video-modal" class="video-form-modal">
    <button class="close" on:click={onClose}>
      <Icon name="x" />
    </button>
    <div>
      <h1>{$format('label.VIDEO_MODAL_NEW_VIDEO')}</h1>
      <p>{$format('label.DESCRIPTION.VIDEO_MODAL_VIDEO_FORM')}</p>
    </div>

    <div class="modal-body">
      <VideoUploadForm
        bind:rulename
        bind:url
        bind:invalidRulename
        bind:uploadError
        bind:validationError
        bind:errorMessage
        bind:currentRulenames
        {onValidation}
      />
    </div>
  </ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={onUploadVideo} disabled={!url.length || invalidRulename || validationError}>
      {$format('label.VIDEO_MODAL_UPLOAD_VIDEO')}
    </Button>
  </ModalFooter>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./video-modal.scss"></style>
